import { render, staticRenderFns } from "./AtividadeFormulario.vue?vue&type=template&id=67fbbcaf&"
import script from "./AtividadeFormulario.vue?vue&type=script&lang=js&"
export * from "./AtividadeFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports